import { p as proxyCustomElement, H, h, F as Fragment, a as Host } from './index.js';

const dividerCss = ":host{align-items:center;display:flex;justify-content:center}.line{background-color:var(--jw-theme-surface-divider-color);flex:1;height:1px;width:100%}.or-text{background-color:var(--jw-theme-surface-tile-bg-color);color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.75rem;font-weight:700;letter-spacing:.03em;line-height:1rem;padding:.25rem .75rem;text-transform:uppercase}:host([type=vertical]){min-height:100%;width:1px}:host([type=vertical]) .line{height:100%;max-height:100%;min-height:1.5rem;width:100%}";

const WuiDivider = /*@__PURE__*/ proxyCustomElement(class WuiDivider extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Type
         */
        this.type = 'horizontal';
    }
    render() {
        return (h(Host, { key: '119d49d7e8ad13b698f4d82144d8845698f00ff7' }, h("div", { key: '1c45d788691d102770d24a3b7248e436a3f9986c', class: "line" }), this.type === 'horizontal-or' && (h(Fragment, { key: '3d5bf95bb5083c089506df634812d490dd6f1327' }, h("div", { key: 'a1110d39862de11b31d8f0dd3b146bd9455bb589', class: "or-text" }, "OR"), h("div", { key: '542a7c7420d27cb84dbf5cfd9a7d6b120d6a5560', class: "line" })))));
    }
    static get style() { return dividerCss; }
}, [257, "wui-divider", {
        "type": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-divider"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-divider":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDivider);
            }
            break;
    } });
}
defineCustomElement();

export { WuiDivider as W, defineCustomElement as d };
